import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { Button } from '../../Button';
import './Contact.css';

function Contact() {
    const [formStatus, setFormStatus] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [success, setSuccess] = useState(false);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setDisabled(true);
        setFormStatus(false);

        axios({
            method: 'POST',
            url: 'https://nocodeform.io/f/62215793c31c70ffb132a599',
            headers: {
                'Content-type': 'application/json'
            },
            data: {
                name: name,
                email: email,
                subject: subject,
                message: message
            }
        }).then((response) => {
            // handle success
            setFormStatus(true);
            setSuccess(true);
            //setName('');
            //setEmail('');
            //setSubject('');
            //setMessage('');
        }).catch(function (error) {
            // handle error
            setFormStatus(true);
            setSuccess(false);
        }).then((response) => {
            // always executed
            setTimeout(() => setFormStatus(false), 20000);
            setDisabled(false);
        });
    };

    return (
        <>
            <Helmet>
                <title>Kai Cheng | Contact</title>
                <meta name='description' content='Kai Cheng | Contact' />
            </Helmet>
            <h1>Contact Me!</h1>
            <section className='resume__container mb-50'>
                <form className='element' onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col-50 mb-20'>
                            <label htmlFor='name'>Your Name: *</label>
                            <br />
                            <input
                                type='text'
                                id='name'
                                name='name'
                                className='form-field sbs'
                                placeholder='Your Name'
                                onChange={e => setName(e.target.value)} value={name}
                                required
                            />
                        </div>
                        <div className='col-50 mb-20'>
                            <label htmlFor='email' className='sbs2'>Your Email: *</label>
                            <input
                                type='email'
                                id='email'
                                name='email'
                                className='form-field sbs2'
                                placeholder='email@email.com'
                                onChange={e => setEmail(e.target.value)} value={email}
                                required
                            />
                        </div>
                    </div>
                    <div className='row mb-20'>
                        <div className='col-100'>
                            <label htmlFor='subject'>Subject: *</label>
                            <input
                                type='text'
                                id='subject'
                                name='subject'
                                className='form-field'
                                placeholder='Subject'
                                autoComplete='off'
                                onChange={e => setSubject(e.target.value)} value={subject}
                                required
                            />
                        </div>
                    </div>
                    <div className='row mb-20'>
                        <label htmlFor='message'>Message: *</label>
                        <textarea
                            type='text'
                            id='message'
                            name='message'
                            className='form-field'
                            rows='5'
                            placeholder='Your message'
                            onChange={e => setMessage(e.target.value)} value={message}
                            required
                        />
                    </div>
                    <Button buttonStyle='btn--submit' buttonSize='btn--small' buttonColor='blue' disabled={disabled}>
                        {disabled ? 'Sending...' : 'Send Message'}
                    </Button>
                    {formStatus ? (
                        <div className={`row alert ${success ? 'alert-success' : 'alert-failed'} mt-20`}>
                            {success ? 'Your message has been sent.' : 'Failed to send message. Please try again.'}
                        </div>
                    ) : (
                        ''
                    )}
                </form>
            </section>
        </>
    );
}

export default Contact;
